import { Component, Input } from '@angular/core';
import { UnifiedArray } from '@pure1/data';
import { Router } from '@angular/router';

/**
 * ArrayCardActionComponent
 *
 * A generic status card — typically used at the beginning of a list of array cards.
 * It provides a summary or call-to-action for a set of arrays.
 *
 * Inputs:
 *  - title: The title of the card.
 *  - mainTextHeader: The main header text in the card.
 *  - mainTextBody: The main body text in the card.
 *  - callToActionText: The text for the call-to-action button.
 *  - callToActionLink: The router link to navigate to when the call-to-action is clicked.
 *
 * Usage:
 *  <arrays-card-action
 *    [title]="'Status Overview'"
 *    [mainTextHeader]="'Welcome!'"
 *    [mainTextBody]="'Here is a summary of your arrays.'"
 *    [callToActionText]="'Get Started'"
 *    [callToActionLink]="'/some/path'">
 *  </arrays-card-action>
 */
@Component({
    selector: 'arrays-card-action',
    templateUrl: 'arrays-card-action.component.html',
})
export class ArrayCardActionComponent {
    @Input() readonly title: string;
    @Input() readonly mainTextHeader: string;
    @Input() readonly mainTextBody: string;
    @Input() readonly callToActionText: string;
    @Input() readonly callToActionLink: string;

    constructor(private readonly router: Router) {}

    /**
     * Handles the click event for the call-to-action button.
     * Navigates to the specified callToActionLink.
     */
    callToActionClickHandler(): void {
        this.router.navigate([this.callToActionLink]);
    }
}
